<!-- 特价申请/活动管理（动态列表：检索条件与表格列由接口配置驱动，参考 basebrandList 的 jurHead/jurTableVo 模式） -->
<template>
  <div class='page_content'>
    <!-- <subComponents  ref="showSelectData"></subComponents> -->
    <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false"
      append-to-body custom-class="drawer_box" direction="ltr" size="100%">
      <activityAction v-if="showStatus" ref="activityAction" @drawerCancel="drawerCancel" :actionData="actionData"></activityAction>
    </el-drawer>

    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
      <div class="page_content_top_line">
        <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
      </div>
    </div>
    <div class="page_content_center">
      <u-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="(tableHeight / 2) + 50" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini" :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }" @row-click="rowClick" :row-height="20" row-key="index" use-virtual :big-data-checkbox="true">
        <u-table-column label="选择操作" width="80">
          <template slot-scope="scope">
            <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
              <i class="el-icon-thumb"></i>
            </el-radio>
          </template>
        </u-table-column>
        <!-- 动态渲染表格列，元数据来自 pageShowData.jurTableVo.jurconfigtable（getJur 接口返回，支持右上角"设置"自定义） -->
        <u-table-column align="center" show-overflow-tooltip v-if="col.isShow == 1" v-for="(col, colKey) in pageShowData.jurTableVo.jurconfigtable"
          :key="colKey" :prop="col.entityField" :label="col.showField" :min-width="col.fieldWeight || 100">
          <template slot-scope="scope">
            <!-- 日期 -->
            <div v-if="col.fieldType == 'date'">
              <span v-if="scope.row[col.entityField]">{{ $common.getLocalTime(scope.row[col.entityField]) }}</span>
            </div>
            <!-- 日期时间 -->
            <div v-else-if="col.fieldType == 'dateTime'">
              <span v-if="scope.row[col.entityField]">{{ $common.getLocalTime(scope.row[col.entityField], true) }}</span>
            </div>
            <!-- 枚举/状态 -->
            <span v-else-if="col.fieldType == 'formatter'">
              {{ $common.getIsGsp(col.formatterContent, scope.row[col.entityField]) }}
            </span>
            <!-- 穿透链接 -->
            <span v-else-if="col.isRift == 1">
              <a @click="toDetail(scope.row[col.riftField])">{{ scope.row[col.entityField] }}</a>
            </span>
            <span v-else>{{ scope.row[col.entityField] }}</span>
          </template>
        </u-table-column>
      </u-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
    <!-- 明细 -->
    <div class="page_content_center" style="margin-top: 0;">
      <el-table v-if="detailTableColumns.length" stripe :data="detailListData" :height="(tableHeight / 2) - 50"
        border style="width: 100%" highlight-current-row size="mini"
        :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <template v-for="(col, colKey) in detailTableColumns">
          <el-table-column align="center" show-overflow-tooltip :key="'detail_' + colKey"
            :prop="col.entityField" :label="col.showField" :min-width="col.fieldWeight || 100">
            <template slot-scope="scope">
              <span v-if="col.fieldType == 'date'">
                <span v-if="scope.row[col.entityField]">{{ $common.getLocalTime(scope.row[col.entityField]) }}</span>
              </span>
              <span v-else-if="col.fieldType == 'dateTime'">
                <span v-if="scope.row[col.entityField]">{{ $common.getLocalTime(scope.row[col.entityField], true) }}</span>
              </span>
              <span v-else-if="col.fieldType == 'formatter'">
                {{ $common.getIsGsp(col.formatterContent, scope.row[col.entityField]) }}
              </span>
              <span v-else>{{ scope.row[col.entityField] }}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>

    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" :smId="cmId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <!-- 自定义设计 -->
    <customDesign ref="customDesign"></customDesign>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue"

 import activityAction from "@/components/activityAction.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { SearchScheme,activityAction },
  data() {
    //这里存放数据
    return {
      // 页面动态配置（getJur 接口返回：jurHead 检索条件 / jurTableVo 表格列 / jurFormVoList 表单）
      pageShowData: {},
      formDataList: [],
      tableHeight: 0,
      getRequestData: {},
      returnData: {
        pages: 0,  // 总页数
        total: 0,  // 总条数
        pageNum: 0,  // 当前页数
        list: []
      },

      buttonList: [],

      selectedDataIndex: 0,
      showStatus: false,
      actionData: {},
      seTitle: "",//检索
      DialogVisible: false,
      seWidth: '0',
      seId: 0,
      cmId: 0,
      parentSearchData: {},
      sField: "",

    };
  },
  //监听属性 类似于data概念
  computed: {
    // 明细表格列配置：从 getJur 的 jciType==2 获取
    detailTableColumns() {
      if (this.pageShowData && this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.length) {
        var detailForm = this.pageShowData.jurFormVoList.find(item => item.jciType == 2)
        if (detailForm && detailForm.jurconfigform && detailForm.jurconfigform.length) {
          return detailForm.jurconfigform.filter(item => item.isShow == 1)
        }
      }
      return []
    },
    // 明细表格数据：取主表选中行的 detailList 字段
    detailListData() {
      var row = this.returnData.list[this.selectedDataIndex]
      if (row && row.detailList && Array.isArray(row.detailList)) {
        return row.detailList
      }
      return []
    },
  },
  //监控data中的数据变化
  watch: {
    "getRequestData.cmName"() {
      if (this.getRequestData.cmName == '') {
        this.getRequestData.cmId = ''
      }
    },


  },
  //方法集合
  methods: {
    // 点击主表行选中，触发明细数据更新
    rowClick(row) {
      var index = this.returnData.list.indexOf(row)
      if (index > -1) this.selectedDataIndex = index
    },
    // 获取页面动态配置（检索条件 + 表格列 + 表单配置），右上角"刷新"按钮也会调用该方法
    async getPageInfo() {
        console.log(this.$route.path,1111111111111)
      var pathId = parent.getMenuInfo(this.$route.path)
      let responseData = await this.$http.getJur({ ids: [pathId.jurId] })
      if (responseData.status == 200) {
        this.pageShowData = responseData.result
        this.formDataList = this.pageShowData.jurFormVoList
        var obj = {}
        if (this.pageShowData.jurHead) {
          obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', 'rows', 30)
        } else {
          obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        }
        for (const key in obj) {
          this.$set(this.getRequestData, key, obj[key])
        }
        this.getDataList()
        this.getButtonList()
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
    // 打开自定义设计（右上角"设置"按钮）
    openFormDesign() {
      let pathInfo = parent.getMenuInfo(this.$route.path)
      this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
    },
    //结束时间改成最后时间
    changeTime(val) {
      if (val) {
        var time = val + 24 * 60 * 60 * 1000 - 1
        this.getRequestData.end = time
      }
    },
    // 点击穿透字段 传参单号
    toDetail(orderId) {
      if (orderId) {
        // 设置为true 打开穿透组件首页    
        var isPenetrate = true
        // 设置缓存 存入点击单号
        this.resetSetItem('penetrateOrderId', orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage({  //向窗口发送MessageEvent消息
          cmd: 'returnFormJson',
          params: { isPenetrate } //参数
        }, '*');
      }
    },
    // 检索Id, 索引(表格中), 标识
    openSearch({ sId, index, type, sField }) {
      this.DialogVisible = true
      this.seId = sId
      this.sField = sField
      this.parentSearchData[sField] = this.getRequestData[sField]
    },
    //检索带回数据
    changeInputModel(val) {
      console.log(val);
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        if (val.cmId) {//销售单位
          this.cmId = val.cmId
        }
        this.paramValue(val)
      }
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.getRequestData[item] = val[item]
      })
    },
    getSeWidth(e) {
      // console.log(e);
      this.seWidth = e + "%";
    },
    getWidth(e) {
      // console.log(e);
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      // console.log(e);
      this.seTitle = e;
    },


    isShowData(name, value) {
      switch (name) {
        case 'cmId':
          var info = sessionStorage.getItem('selectCustomerData')
          if (info) {
            let infoTwo = JSON.parse(info)
            this.getRequestData.cmName = infoTwo.cmName
          }
          this.getRequestData[name] = value
          break;
        default:
          this.getRequestData[name] = value


      }


    },

    // 动作集合
    actionSet(actionData) {
      switch (actionData.actionType) {
        case 0:
          this.showStatus = true
          this.actionData = {
            cate: 0,
            formData: this.formDataList,
            oldData: '',
            orderId: '',
            printSouce: '',
            printJurId: ''
          }
          break;
        case 1:
          var dataInfo = this.returnData.list[this.selectedDataIndex]
          if (!dataInfo) {
            this.$message({
              message: '请先选中要操作的数据',
              type: 'error'
            });
            return false
          }
          this.showStatus = true
          this.actionData = {
            cate: 1,
            formData: this.formDataList,
            oldData: dataInfo,
            orderId: '',
            printSouce: '',
            printJurId: ''
          }
          break;
        case 2:
          this.delDataAction()
          break;
      }
    },
    // 子组件触发关闭/刷新
    drawerCancel(e) {
      this.showStatus = false
      if (e == 1) this.getDataList()
    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1
      this.getDataList()
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val
      this.getDataList()
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1
      this.getRequestData.rows = val
      this.getDataList()
    },


    // 获取数据列表
    async getDataList() {
      let responseData = await this.$http.queryActivity(this.getRequestData)
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list
        this.returnData.pages = responseData.result.pages
        this.returnData.total = responseData.result.total
        this.returnData.pageNum = responseData.result.pageNum
        this.selectedDataIndex = 0
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },


    // 删除数据
    delDataAction() {
      var dataInfo = this.returnData.list[this.selectedDataIndex]
      if (!dataInfo) {
        this.$message({
          message: '请先选中要操作的数据',
          type: 'error'
        });
        return false
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        var delData = {
          // 活动记录主键，若后端主键字段名不同请替换
          ids: [dataInfo.id]
        }
        let responseData = await this.$http.delActivity(delData)
        if (responseData.status == 200) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });

          this.getDataList()
        } else {
          this.$message({
            message: responseData.message,
            type: 'error'
          });
        }

      }).catch(() => { });

    },

    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log(this.$route.path,2222222222222)
    this.getPageInfo()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}
</style>
